<div class="background-image">
  <tc-header>
    <tc-logo color="white" tagline="true"></tc-logo>
  </tc-header>

  <tc-validate-email
    (validateIdentity)="onValidateIdentity($event)"
    [pending]="pending$ | async"
    [validateError]="error$ | async"
    [validateValue]="value$ | async"
    [linkValid]="isLinkValid$ | async"
    [verify2FAError]="verify2FAError$ | async"
    [identity]="identity$ | async"
    [backupCodes]="backupCodes$ | async"
  ></tc-validate-email>
  <tc-title></tc-title>
</div>
